const defaultState = () => {
  return {
    messages: [],
    newChatMessagesCount: 0
  }
}

const state = defaultState()

const getters = {
  messages: state => state.messages,
  newChatMessagesCount: state => state.newChatMessagesCount
}

const mutations = {
  messages(state, payload) {
    state.messages.unshift(payload)
  },
  newChatMessagesCount(state, payload) {
    state.newChatMessagesCount = payload
  },
  resetModule(state) {
    Object.assign(state, defaultState())
  }
}

const actions = {
  setMessage({ commit }, payload) {
    commit('messages', payload)
  },
  setNewChatMessagesCount({ commit }, payload) {
    commit('newChatMessagesCount', payload)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
